import { esc } from '@/utils/escape';

export function generateCtaHTML(data: any, settings: any): string {
  return `  <!-- CTA -->
  <section class="cta" id="kontakt">
    <div class="container">
      <h2>${esc(data.title)}</h2>
      <p>${esc(data.subtitle)}</p>
      <div class="cta__actions">
        <a href="tel:${data.phone?.replace(/\s/g, "")}" class="btn btn--accent">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
          ${esc(data.phone)}
        </a>
        <a href="mailto:${data.email}" class="btn btn--secondary-light">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
          ${esc(data.email)}
        </a>
      </div>
    </div>
  </section>`;
}
